import React, { useEffect, useRef, useState } from 'react'
import '../../landingAssets/css/custom-animated.css';
import '../../landingAssets/css/default.css';
import '../../landingAssets/css/font-awesome.min.css';
import '../../landingAssets/css/magnific-popup.css';
import '../../landingAssets/css/magnific.dark.css';
import '../../landingAssets/css/magnific.rtl.css';
import '../../landingAssets/css/main.css';
import '../../landingAssets/css/style.css';
import "./user-dashboard.min.css"
import Loader from '../landing/loder/Loader.jsx';
import FooterHomeOne from '../landing/Home/FooterHomeOne.jsx';
import { Modal, OverlayTrigger, ProgressBar, Tooltip } from 'react-bootstrap';
import Select from 'react-select'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import AvatarEditor from 'react-avatar-editor'
import { useSelector } from 'react-redux';
import { getCompanyProfile, updateCompanyProfile, getAllPlan, getAllPaymentHistory, getAllCompanyModules, createCompanyUser, getAllCompanyUsers, editCompanyUser, deleteCompanyUser } from '../../services/User/api.js';
import CartPage from '../LandingCart/CartPage.js';
import { logOut } from '../../services/User/api';
import { compareAsc, format } from 'date-fns';
import axios from 'axios';
import Swal from 'sweetalert2';
import { parseISO, differenceInMonths, differenceInYears } from 'date-fns';
import config from '../../services/utils/config.json';
import { ReactComponent as TaskIcon } from './../LandingModule/task-icon.svg';
import { ReactComponent as ChecklistIcon } from './../LandingModule/checklist-icon.svg';
import { ReactComponent as FlowIcon } from './../LandingModule/workflow-icon.svg';
import { ReactComponent as ErpIcon } from './../LandingModule/erp-icon.svg';
import { ReactComponent as PosIcon } from './../LandingModule/pos-icon.svg';
import { Link } from 'react-router-dom';
import { UserAuth } from '../auth/Auth.js';
import { PrivateAxios, PrivateAxiosFile, url } from '../../environment/AxiosInstance.js';
import { ErrorMessage, SuccessMessage } from '../../environment/ToastMessage.js';
import VideoTutorialModalNewUser from './VideoTutorialModalNewUser.js';




const BASE_URL = config['PUBLIC_URL'];



function UserDashboardIndex() {
  const { Logout, userDetailsLogin, companyDetails } = UserAuth();
  const [purchaseData, setPurchaseData] = useState([]);
  const [planData, setPlanData] = useState([]);
  // const planDetails = useSelector((state) => state.selectedPlan);
  const [planIds, setplanIds] = useState([]);
  const [modules, setModules] = useState([]);
  const token = localStorage.getItem('companyToken');
  const skipOrGetStart = useSelector((state) => state.skipGet);
  const [companyMeta, setCompanyMeta] = useState({});
  const [purchasedModules, setPurchasedModules] = useState([]);
  const [selectedModules, setSelectedModules] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [planHistory, setPlanHistory] = useState([]);
  console.log(planHistory, 'planHistory');

  const [totalAmountPaid, setTotalAmountPaid] = useState(0);
  const [remainingUsers, setRemainingUsers] = useState(0);
  const [assignedUsers, setAssignedUsers] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [remainingDays, setRemainingDays] = useState(0);
  const [paymentData, setPaymentData] = useState([]);
  const [companyUserList, setCompanyUserList] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [companyUser, setCompanyUser] = useState({
    name: '',
    email: '',
    password: '',
    contact_no: 0,
    whats_app_number: 0,
    profile_image: "",
    w_isd: '',
    p_isd: ''
  });

  const [userDetails, setUserDetails] = useState({
    company_name: '',
    contact_no: '',
    whats_app_number: '',
    total_employees: '',
    turn_over: '',
    location: '',
    logo: null,
  });
  const [userWithModule, setUserWithModule] = useState([]);
  const [allowEdit, setAllowEdit] = useState('');
  const [errors, setErrors] = useState({
    name: '',
    email: '',
    password: '',
    contact_no: '',
    whats_app_number: '',
  });

  const validateUserInfo = () => {
    let isValid = true;
    let newErrors = { ...errors };

    // Name validation
    if (!companyUser.name) {
      newErrors.name = 'Name is required';
      isValid = false;
    } else {
      newErrors.name = '';
    }



    // Email validation
    if (!companyUser.email) {
      newErrors.email = 'Email is required';
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(companyUser.email)) {
      newErrors.email = 'Email is invalid';
      isValid = false;
    } else {
      newErrors.email = '';
    }

    // Password validation
    if (!companyUser.password) {
      newErrors.password = 'Password is required';
      isValid = false;
    } else if (companyUser.password.length < 8) {
      newErrors.password = 'Password must be at least 8 characters long';
      isValid = false;
    } else if (!/[A-Z]/.test(companyUser.password)) {
      newErrors.password = 'Password must contain at least one uppercase letter';
      isValid = false;
    } else if (!/[0-9]/.test(companyUser.password)) {
      newErrors.password = 'Password must contain at least one number';
      isValid = false;
    } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(companyUser.password)) {
      newErrors.password = 'Password must contain at least one special character';
      isValid = false;
    } else {
      newErrors.password = '';
    }

    // Contact number validation (generic for multiple countries with min 12 digits)
    if (!companyUser.contact_no) {
      newErrors.contact_no = 'Contact number is required';
      isValid = false;
    } else if (!/^\+?[1-9]\d{11,14}$/.test(companyUser.contact_no)) {
      // This regex matches phone numbers with an optional '+' sign followed by a country code and phone number of 12 to 15 digits
      newErrors.contact_no = 'Contact number is invalid';
      isValid = false;
    } else {
      newErrors.contact_no = '';
    }

    // WhatsApp number validation (generic for multiple countries with min 12 digits)
    if (!companyUser.whats_app_number) {
      newErrors.whats_app_number = 'WhatsApp number is required';
      isValid = false;
    } else if (!/^\+?[1-9]\d{11,14}$/.test(companyUser.whats_app_number)) {
      // Same regex as contact number for WhatsApp number
      newErrors.whats_app_number = 'WhatsApp number is invalid';
      isValid = false;
    } else {
      newErrors.whats_app_number = '';
    }

    // Update errors state (assuming you have a setErrors function to update the state)
    setErrors(newErrors);
    return isValid;

  };



  const handleCompanyUserChange = async (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setCompanyUser((prev) => ({
      ...companyUser,
      [name]: value
    }));
  };

  const handleUpdateChange = async (e) => {
    setUpdateCompanyUser(() => ({
      ...updateCompanyUser,
      [e.target.name]: e.target.value
    }))
  };

  const populateUpdateData = async (user) => {
    setUpdateCompanyUser(user);
    setUserWithModule(user.User_With_Module.map((mod) => ({ value: mod.module.id, label: mod.module.module_name })));
  };

  // const handleCompanyUserRole = async (role) => {
  //   const value = role;
  //   setCompanyUser((prev) => ({
  //     ...companyUser,
  //     ['role']: value
  //   }));
  // };

  const handleCompanyUserPermission = (selected) => {
    setSelectedModules(selected);
  };

  const handleCompanyUserPermissionUpdate = (selected) => {
    setUserWithModule(selected);
  };

  const handleCompanyUserContact = async (contact) => {
    const contact_no = contact.phone;
    setCompanyUser((prev) => ({
      ...companyUser,
      ['contact_no']: contact_no
    }));
  };

  const handleUpdateCompanyUserContact = async (contact) => {
    const contact_no = contact.phone;
    setUpdateCompanyUser(() => ({
      ...updateCompanyUser,
      ['contact_no']: contact_no
    }));
  }

  const handleCompanyUserWhatsApp = async (contact) => {
    const whats_app = contact.phone;
    setCompanyUser((prev) => ({
      ...companyUser,
      ['whats_app_number']: whats_app
    }));
  };

  const handleUpdateCompanyUserWhatsApp = async (contact) => {
    const whats_app = contact.phone;
    setUpdateCompanyUser(() => ({
      ...updateCompanyUser,
      ['whats_app_number']: whats_app
    }));
  };




  //tab active
  const [activeTab, setActiveTab] = useState('accountinformation');

  const handleUsersGoClick = () => {
    setActiveTab('users');
  };

  const handlePaymentHistoryGoClick = () => {
    setActiveTab('paymentHistory');
  };

  const handlePlanDetailsGoClick = () => {
    setActiveTab('plan');
  };

  useEffect(() => {
    const tabContent = document.getElementById(activeTab);
    if (tabContent) {
      tabContent.scrollTop = 0;
    }
  }, [activeTab]);

  useEffect(() => {
    const fetchCompanyProfile = async () => {
      try {
        const response = await getCompanyProfile(token);
        setShowImage(`${BASE_URL}/uploads/${response.data.data.logo}`);
        setUserDetails(response.data.data);
        setCompanyMeta(response.data.meta);
        let planId = response.data.data.User_with_Plan.map((item) => item.plan.id);
        setplanIds(planId);
        const plansData = await getAllPlan();
        let selectedPlans = [];
        for (let i = 0; i < plansData.data.length; i++) {
          if (planIds.includes(plansData.data[i].id)) {
            selectedPlans.push(plansData.data[i]);
          }
        }

        setModules(selectedPlans);
        let companyMoudlesList = await getAllCompanyModules(token);
        companyMoudlesList = companyMoudlesList.data.data.flatMap((modData) => {
          return modData.plan.modules.map(element => {
            return { value: element.module.id, label: element.module.module_name };
          });
        });
        const paymentHistoryResponse = await getAllPaymentHistory(token);
        setPurchasedModules(companyMoudlesList);
        setPurchaseData(paymentHistoryResponse.data);
        const allCompanyUsers = await getAllCompanyUsers(token);
        setCompanyUserList(allCompanyUsers.data.data);
      } catch (error) {
        console.error('Failed to fetch order history:', error.message);
      }
    };

    if (token) {
      fetchCompanyProfile();
    }
  }, [token]);







  //profile image
  const [image, setImage] = useState(null);
  const [showImage, setShowImage] = useState('');
  const [scale, setScale] = useState(1.0);
  const editorRef = useRef(null);

  const handleScaleChange = (event) => {
    const scale = parseFloat(event.target.value);
    setScale(scale);
  };

  const handleSave = async () => {
    if (editorRef.current) {
      try {
        const canvas = editorRef.current.getImage();
        const dataURL = canvas.toDataURL();
        const file = dataURLtoFile(dataURL, 'avatar.png');

        const formData = new FormData();
        formData.append('logo', file); // name must match backend field

        const res = await PrivateAxiosFile.post(
          `/user/logo-upload/${companyDetails.id}`,
          formData
        );

        if (res.data.success) {
          Swal.fire({
            icon: 'success',
            title: 'Logo updated!',
            text: res.data.message || 'Your company logo was updated.',
            timer: 2000,
            showConfirmButton: false,
          });

          // Update the image preview immediately
          setShowImage(URL.createObjectURL(file));

        } else {
          Swal.fire({
            icon: 'error',
            title: 'Upload failed',
            text: res.data.message || 'Something went wrong.',
          });
        }

        handleProfileImageModalClose();
        window.location.reload();
      } catch (e) {
        console.error('Image upload error:', e);
        Swal.fire({
          icon: 'error',
          title: 'Upload failed',
          text: 'Could not upload profile image.',
        });
        handleProfileImageModalClose();
      }
    }
  };
  function dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  //profile image end
  //role
  const permissionFor = [
    { value: 'crm', label: 'CRM' },
    { value: 'ims', label: 'Inventory Management' },
    { value: 'bms', label: 'BMS' },
    { value: 'prdms', label: 'Production Management' },
    { value: 'prjms', label: 'Project Management' },
    { value: 'hr', label: 'HR' },
    { value: 'purms', label: 'Purchase Management' }
  ]
  //role
  const roleType = [
    { value: 'select', label: '-Select-' },
    { value: 'owner', label: 'Owner' },
    { value: 'member', label: 'Member' }
  ]
  //profile image modal
  const [profileImageModalShow, setProfileImageModalShow] = useState(false);
  const handleProfileImageModalClose = () => setProfileImageModalShow(false);
  const handleProfileImageModalShow = () => setProfileImageModalShow(true);
  //edit user modal
  const [editUserShow, setEditUserShow] = useState(false);
  const editUserModalClose = () => {
    setUpdateCompanyUser({
      id: '',
      name: '',
      email: '',
      password: '',
      contact_no: '',
      whats_app_number: '',
      user_photo: '',
    });
    setUserWithModule([]);
    setSelectedFile(null);
    setEditUserShow(false);
  };

  // const editUserModalShow = (userId) => {
  //   setSelectedUserId(userId);
  //   setEditUserShow(true);
  // };
  //view user modal
  const [viewUserShow, setViewUserShow] = useState(false);
  const viewUserModalClose = () => setViewUserShow(false);


  const [updateCompanyUser, setUpdateCompanyUser] = useState({});



  //Create user modal
  const [createUserShow, setCreateUserShow] = useState(false);
  const createUserModalClose = () => setCreateUserShow(false);
  const createUserModalShow = () => setCreateUserShow(true);
  //delete modal
  const [deleteShow, setDeleteShow] = useState(false);
  const deleteModalClose = () => setDeleteShow(false);
  const deleteModalShow = (userId) => {
    setSelectedUserId(userId);
    setDeleteShow(true);
  };
  // Storage modal
  const [showStorageModal, setShowStorageModal] = useState(false);
  const handleStorageModalClose = () => setShowStorageModal(false);
  const handleStorageModalShow = () => setShowStorageModal(true);

  // Plan Modal
  const [showPlanModal, setShowPlanModal] = useState(false);
  const handlePlanModalClose = () => setShowPlanModal(false);
  const handlePlanModalShow = () => setShowPlanModal(true);
  //Loader
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  });
  // let planIds = userDetails.User_with_Plan.map((item)=>item.plan.id);
  // console.log(planIds,"planid");


  function determinePlanLength(createdAtISO, planExpirationDateISO) {
    console.log(createdAtISO, planExpirationDateISO, 'createdAtISO, planExpirationDateISO')
    const createdAt = parseISO(createdAtISO);
    const planExpirationDate = parseISO(planExpirationDateISO);

    // Calculate the difference in months and years
    const diffInMonths = differenceInMonths(planExpirationDate, createdAt);
    const diffInYears = differenceInYears(planExpirationDate, createdAt);

    let lengthType;
    if (diffInYears >= 1) {
      lengthType = 'Annual';
    } else if (diffInMonths >= 1) {
      lengthType = 'Monthly';
    } else {
      lengthType = 'less than a month';
    }

    return lengthType;
  }
  // new code====================================================================================================================
  const editUserModalShow = async (userId) => {
    try {
      const res = await PrivateAxios.get(`/user/company-user/${userId}`);
      const user = res.data.data;

      // Set all fields including module selection and phone numbers
      setUpdateCompanyUser({
        id: user.id,
        name: user.name || '',
        email: user.email || '',
        p_isd: user.p_isd || '91',
        w_isd: user.w_isd || '91',
        password: '', // keep blank for security
        contact_no: user.phone_number || '',
        whats_app_number: user.whatsapp_no || '',
        user_photo: user.user_photo || '',
      });

      // Set existing modules
      if (user.User_With_Module) {
        const formattedModules = user.User_With_Module.map(mod => ({
          value: mod.module.id,
          label: mod.module.module_name
        }));
        setUserWithModule(formattedModules);
      }
      setSelectedUserId(userId);
      setEditUserShow(true);
    } catch (err) {
      console.error("Failed to fetch user details:", err);
      Swal.fire({
        title: 'Error!',
        text: 'Could not load user data.',
        icon: 'error',
        timer: 3000,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

    }
  };

  const handleUserUpdate = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append('id', selectedUserId);
    data.append('name', updateCompanyUser.name);
    data.append('email', updateCompanyUser.email);
    data.append('password', updateCompanyUser.password || '');
    data.append('contact_no', updateCompanyUser.contact_no);
    data.append('whats_app_number', updateCompanyUser.whats_app_number);
    data.append('w_isd', updateCompanyUser.w_isd);
    data.append('p_isd', updateCompanyUser.w_isd);

    if (selectedFile) {
      data.append('user_photo', selectedFile);
    }

    try {
      const res = await PrivateAxiosFile.post(`/user/update-user`, data);

      if (res.data.success) {
        Swal.fire({
          title: 'Success!',
          text: res.data.msg,
          icon: 'success',
          timer: 3000,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
        editUserModalClose();
        fetchCompanyUsers(); // Refresh table
      } else {
        Swal.fire({
          title: 'Error!',
          text: res.data.msg,
          icon: 'error',
          timer: 3000,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
      }
    } catch (err) {
      console.error('Update user error:', err);
      ErrorMessage(err?.response?.data?.msg || 'Failed to update user');
    }
  };

  const viewUserModalShow = async (userId) => {
    try {
      const res = await PrivateAxios.get(`/user/company-user/${userId}`);
      console.log(res.data, 'fff');

      setUpdateCompanyUser(res.data.data);
      setViewUserShow(true);
    } catch (err) {
      console.error('Failed to load user details:', err);
    }
  };
  useEffect(() => {
    if (companyDetails) {
      setCompanyProfile({
        company_name: companyDetails.company_name || '',
        owner_name: companyDetails.owner_name || '',
        company_phone: companyDetails.company_phone || '',
        whatsapp_number: companyDetails.whatsapp_number || '',
        total_employees: companyDetails.total_employees || '',
        turn_over: companyDetails.turn_over || '',
        address: companyDetails.address || '',
        c_p_isd: companyDetails.c_p_isd || '',
        w_isd: companyDetails.w_isd || ''
      });
    }

  }, [companyDetails]);



  // Controlled state
  const [companyProfile, setCompanyProfile] = useState({
    company_name: '',
    owner_name: '',
    company_phone: '',
    whatsapp_no_company: '',
    whatsapp_number: '',
    total_employees: '',
    turn_over: '',
    address: ''
  });

  // Handle text input changes (support number fields as string)
  const handleChange = (e) => {
    const { name, value, type } = e.target;
    // For phone/whatsapp fields, allow only digits and keep as string
    if (name === 'company_phone' || name === 'whatsapp_no_company' || name === 'whatsapp_number') {
      // Remove non-digit characters
      const digits = value.replace(/\D/g, '');
      setCompanyProfile(prev => ({ ...prev, [name]: digits }));
    } else {
      setCompanyProfile(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleUpdateProfile = async () => {
    try {
      const res = await PrivateAxios.put(`/company/company-update/${companyDetails?.id}`, companyProfile);
      if (res.data.success) {

        Swal.fire({
          title: 'Success!',
          text: 'Profile updated successfully!',
          icon: 'success',
          timer: 3000,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        setAllowEdit("");
      } else {
        Swal.fire({
          title: 'Error!',
          text: 'Update Faild.',
          icon: 'error',
          timer: 3000,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

      }
    } catch (err) {
      console.error("Update error:", err);
      alert("Something went wrong!");
    }
  };
  useEffect(() => {
    console.log(companyDetails?.id, 'companyDetails?.id');

    if (companyDetails?.id) {
      PrivateAxios.get(`/company/cdata/${companyDetails.id}/modules`)
        .then(res => {
          if (res.data.success) {
            console.log(res.data.modules, 'modules');

            setPurchasedModules(res.data.modules);
          }
        })
        .catch(() => {
          setPurchasedModules([]);
        });
    }
  }, [companyDetails]);

  useEffect(() => {
    fetchCompanyStats();
  }, [companyDetails.id]);

  const fetchCompanyStats = async () => {
    try {
      const res = await PrivateAxios.get(`/company/company-stats/${companyDetails.id}`);
      const data = res.data;
      setTotalAmountPaid(data.totalAmountPaid);
      setTotalUsers(data.totalPurchasedUsers);
      setAssignedUsers(data.assignedUsers);
      setRemainingUsers(data.remainingUsers);
    } catch (err) {
      console.error("Stats fetch error", err);
    }
  };
  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const res = await PrivateAxios.get(`/company/plans/${companyDetails.id}`);
        setPlanHistory(res.data.data || []);
      } catch (err) {
        console.error('Error loading plans:', err);
      }
    };

    fetchPlans();
  }, [companyDetails.id]);

  useEffect(() => {
    if (companyDetails?.renew_date) {
      const today = new Date();
      const expiry = new Date(companyDetails.renew_date);
      const diffTime = expiry.getTime() - today.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      setRemainingDays(diffDays > 0 ? diffDays : 0);
    }
  }, [companyDetails]);


  useEffect(() => {
    if (!companyDetails.id) return;
    const fetchPayments = async () => {
      try {
        const res = await PrivateAxios.get(`/company/payment-history/${companyDetails.id}`);


        setPaymentData(res.data.data || []);
      } catch (error) {
        console.error('Error fetching payment history', error);
      }
    };
    fetchPayments();
  }, [companyDetails.id]);

  const fetchCompanyUsers = async () => {
    try {
      const res = await PrivateAxios.get(`/company/active-users/${companyDetails.id}`);
      setCompanyUserList(res.data || []);
    } catch (err) {
      console.error("Error fetching company users:", err);
    }
  };

  useEffect(() => {
    if (companyDetails?.id) {
      fetchCompanyUsers();

    }
  }, [companyDetails?.id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append('name', companyUser.name);
    data.append('email', companyUser.email);
    data.append('password', companyUser.password);
    data.append('contact_no', companyUser.contact_no.slice(2));
    data.append('whats_app_number', companyUser.whats_app_number.slice(2));
    data.append('company_id', userDetailsLogin.company_id); // assuming available
    data.append('p_isd', '91');
    data.append('w_isd', '91');
    if (selectedFile) {
      data.append('user_photo', selectedFile);
    }


    try {
      const response = await PrivateAxiosFile.post('/user/create-user', data);
      if (response.data.success) {
        Swal.fire({
          title: 'Success!',
          text: response.data.msg,
          icon: 'success',
          timer: 3000,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        createUserModalClose(); // close modal
        fetchCompanyUsers();    // refetch users list
      } else {
        Swal.fire({
          title: 'Error!',
          text: response.data.msg,
          icon: 'error',
          timer: 3000,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
      }
    } catch (err) {
      console.error('User creation error:', err);
      ErrorMessage(err?.response?.data?.msg || 'Something went wrong');
    }
  };

  const handleUserDelete = async (e) => {
    e.preventDefault();
    try {
      // Send delete request
      const res = await PrivateAxios.delete(`/user/delete/${selectedUserId}`);

      if (res.data.success) {
        Swal.fire({
          title: 'Success!',
          text: 'User deleted successfully.',
          icon: 'success',
          timer: 3000,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
        // Refresh user list
        const userListRes = await PrivateAxios.get(`/company/active-users/${companyDetails.id}`);
        setCompanyUserList(userListRes.data || []);
      } else {
        Swal.fire({
          title: 'Error!',
          text: 'Failed to delete user.',
          icon: 'error',
          timer: 3000,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
      }
    } catch (err) {
      console.error('Error deleting user:', err);
      ErrorMessage(err?.response?.data?.msg || 'Server error while deleting user.');
    }

    deleteModalClose();
  };


  const sortedPlans = [...planHistory].sort((a, b) =>
    new Date(a.start_date) - new Date(b.start_date)
  );

  const latestPlan = sortedPlans[sortedPlans.length - 1];
  const isFreePlan = latestPlan?.billing_cycle === 'free';
  const today = new Date();
  const renewDate = new Date(companyDetails.renew_date);

  // Expiry check
  const isExpired = renewDate < today;

  // Day difference (positive for future, negative for past)
  const daysDiff = Math.ceil((renewDate - today) / (1000 * 60 * 60 * 24));
  const daysLeft = Math.max(daysDiff, 0);
  const daysExpiredAgo = Math.abs(Math.min(daysDiff, 0));

  // Show Renew if:
  const isPaidRenewable = !isFreePlan && (isExpired || daysLeft <= 3);

  // video tutorial new user button
  const [showVideoNewUserModal, setShowVideoNewUserModal] = useState(false);

  const handleVideoNewUserModalShow = () => setShowVideoNewUserModal(true);
  const handleVideoNewUserModalClose = () => {
    setShowVideoNewUserModal(false);
    localStorage.setItem('videoModalShown', 'true'); // Set flag when closed
  };

  useEffect(() => {
    // Show only if not shown before
    if (!localStorage.getItem('videoModalShown')) {
      setShowVideoNewUserModal(true);
    }
  }, []);

  return (
    <>
      {loading && (
        <div className={`appie-loader ${loading ? 'active' : ''}`}>
          <Loader />
        </div>
      )}

      <div className={`appie-visible ${loading === false ? 'active' : ''}`}>
        <div className='user-account-page'>
          <div>
            <header className="user-account-header-wrap">
              <div className="container">
                <div className="user-account-header-cont">
                  <div className="logo-wrap">
                    <a href='/'><img src={process.env.PUBLIC_URL + 'assets/images/logo-navy.png'} alt="Logo" className="img-fluid brand-name" /></a>
                  </div>
                  <a className="gth-btn-outline d-flex align-items-center" onClick={() => { Logout() }} style={{ cursor: 'pointer' }}>
                    Sign Out <i className="fi fi-br-sign-out-alt mt-1 ms-2"></i>
                  </a>
                </div>
              </div>
            </header>
            <div className="user-account-content-wrapper">
              <div className="container-fluid px-0">
                <div>
                  <ul className="nav nav-tabs gth-tabs user-account-tab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link ${activeTab === 'accountinformation' ? 'active' : ''}`}
                        data-bs-toggle="tab"
                        data-bs-target="#accountinformation"
                        type="button"
                        role="tab"
                        aria-selected={activeTab === 'accountinformation'}
                        onClick={() => setActiveTab('accountinformation')}
                      >
                        <i className="fi fi-sr-user"></i> Profile Information
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link ${activeTab === 'users' ? 'active' : ''}`}
                        data-bs-toggle="tab"
                        data-bs-target="#users"
                        type="button"
                        role="tab"
                        aria-selected={activeTab === 'users'}
                        onClick={() => setActiveTab('users')}
                      >
                        <i className="fi fi-sr-users"></i> Users List
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link ${activeTab === 'plan' ? 'active' : ''}`}
                        data-bs-toggle="tab"
                        data-bs-target="#plan"
                        type="button"
                        role="tab"
                        aria-selected={activeTab === 'plan'}
                        onClick={() => setActiveTab('plan')}
                      >
                        <i className="fi fi-sr-credit-card"></i> Plan Details
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link ${activeTab === 'paymentHistory' ? 'active' : ''}`}
                        data-bs-toggle="tab"
                        data-bs-target="#paymentHistory"
                        type="button"
                        role="tab"
                        aria-selected={activeTab === 'paymentHistory'}
                        onClick={() => setActiveTab('paymentHistory')}
                      >
                        <i className="fi fi-ss-receipt"></i> Payment History
                      </button>
                    </li>
                  </ul>
                  {isExpired && (
                    <div className="alert alert-danger text-center fs-6" role="alert">
                      ❌ Your plan expired {daysExpiredAgo} day{daysExpiredAgo > 1 ? 's' : ''} ago.
                      <Link to="/modules-renew" className="btn btn-danger text-decoration-none ms-2">
                        👉 Renew Now
                      </Link>
                    </div>
                  )}

                  {!isExpired && daysLeft <= 6 && (
                    <div className="alert alert-warning text-center fs-6" role="alert">
                      ⏳ Your plan is expiring in {daysLeft} day{daysLeft > 1 ? 's' : ''}.
                      <Link to="/modules-renew" className="btn btn-warning text-decoration-none ms-2">
                        👉 Renew Now
                      </Link>
                    </div>
                  )}
                  <div className='d-flex justify-content-center'>
                    <button className='btn gth-btn-primary d-flex align-items-center' onClick={handleVideoNewUserModalShow}><i class="fas fa-play me-2"></i> Watch intro video</button>
                  </div>

                  <div className="tab-content user-dashboard-tab-content">
                    <div className={`tab-pane ${activeTab === 'accountinformation' ? 'active' : ''}`} id="accountinformation" role="tabpanel">
                      <div className="container pt-5 pb-4">
                        <div className="row justify-content-center">
                          <div className="col-lg-9 col-md-12 mb-4">
                            <div className="card ghostwhite">
                              <div className="card-body">
                                <div className='user-profile-wrap'>
                                  <div className="profile-image-outer">
                                    <img className="profile-image" src={companyDetails?.logo || process.env.PUBLIC_URL + 'assets/images/user-profile-pictures/profile-user.png'} alt="user" />
                                    {/* <img className="profile-image" width={10} height={10} src={`${showImage}`} alt="user" /> */}
                                    <div className="profile-image-overlay" onClick={() => { setShowImage(`${showImage}`); handleProfileImageModalShow(); }}>
                                      <i class="fi fi-sr-user"></i>
                                      <p>Change Profile Picture</p>
                                    </div>
                                  </div>
                                  <div className="profile-desc">
                                    <div className='form-group'>
                                      <label className='form-label'>Company Name</label>
                                      <div className="editable-field d-flex align-items-center flex-wrap">
                                        <div className="position-relative editable-area">
                                          <button className="profile-edit-btn" onClick={() => setAllowEdit(allowEdit === 'company_name' ? '' : 'company_name')}>
                                            <i className="fi fi-rr-pencil"></i>
                                          </button>
                                          <input
                                            type="text"
                                            name="company_name"
                                            value={companyProfile.company_name}
                                            readOnly={allowEdit !== 'company_name'}
                                            onChange={handleChange}
                                            className="input-field"
                                            style={{
                                              padding: '5px',
                                              borderRadius: '5px',
                                              border: allowEdit === 'company_name' ? '1px solid black' : 'transparent',
                                              background: allowEdit === 'company_name' ? 'white' : 'transparent'
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className='form-group'>
                                      <label className='form-label'>Name</label>
                                      <div className="editable-field d-flex align-items-center flex-wrap">
                                        <div className="position-relative editable-area">
                                          <button className="profile-edit-btn" onClick={() => setAllowEdit(allowEdit === 'owner_name' ? '' : 'owner_name')}>
                                            <i className="fi fi-rr-pencil"></i>
                                          </button>
                                          <input
                                            type="text"
                                            name="owner_name"
                                            value={companyProfile.owner_name}
                                            readOnly={allowEdit !== 'owner_name'}
                                            onChange={handleChange}
                                            className="input-field"
                                            style={{
                                              padding: '5px',
                                              borderRadius: '5px',
                                              border: allowEdit === 'owner_name' ? '1px solid black' : 'transparent',
                                              background: allowEdit === 'owner_name' ? 'white' : 'transparent'
                                            }}
                                          />
                                        </div>
                                        <span className='badge rounded-pill exp-badge-primary-light'>OWNER</span>
                                      </div>
                                    </div>

                                    <div className='form-group'>
                                      <label className='form-label'>Phone</label>
                                      <div className="editable-field">
                                        <div className="position-relative editable-area">
                                          <button className="profile-edit-btn" onClick={() => setAllowEdit(allowEdit === 'company_phone' ? '' : 'company_phone')}>
                                            <i className="fi fi-rr-pencil"></i>
                                          </button>
                                          <div style={{ position: 'relative' }}>
                                            {companyProfile.c_p_isd && (
                                              <span style={{ position: 'absolute', left: 12, top: 8, color: '#888', fontSize: 14, zIndex: 2 }}>+{companyProfile.c_p_isd}</span>
                                            )}
                                            <input
                                              type="text"
                                              name="company_phone"
                                              value={companyProfile.company_phone || ''}
                                              readOnly={allowEdit !== 'company_phone'}
                                              onChange={handleChange}
                                              className="input-field"
                                              placeholder="Enter phone (without ISD)"
                                              style={{
                                                padding: companyProfile.c_p_isd ? '5px 5px 5px 45px' : '5px',
                                                borderRadius: '5px',
                                                border: allowEdit === 'company_phone' ? '1px solid black' : 'transparent',
                                                background: allowEdit === 'company_phone' ? 'white' : 'transparent',
                                                position: 'relative',
                                                zIndex: 1
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className='form-group'>
                                      <label className='form-label'>WhatsApp</label>
                                      <div className="editable-field">
                                        <div className="position-relative editable-area">
                                          <button className="profile-edit-btn" onClick={() => setAllowEdit(allowEdit === 'whatsapp_no_company' ? '' : 'whatsapp_no_company')}>
                                            <i className="fi fi-rr-pencil"></i>
                                          </button>
                                          <div style={{ position: 'relative' }}>
                                            {companyProfile.w_isd && (
                                              <span style={{ position: 'absolute', left: 12, top: 8, color: '#888', fontSize: 14, zIndex: 2 }}>+{companyProfile.w_isd}</span>
                                            )}
                                            <input
                                              type="text"
                                              name="whatsapp_number"  // ✅ correct name
                                              value={companyProfile.whatsapp_number || ''}
                                              readOnly={allowEdit !== 'whatsapp_no_company'}
                                              onChange={allowEdit === 'whatsapp_no_company' ? handleChange : undefined}
                                              className="input-field"
                                              placeholder="Enter WhatsApp (without ISD)"
                                              style={{
                                                padding: companyProfile.w_isd ? '5px 5px 5px 45px' : '5px',
                                                borderRadius: '5px',
                                                border: allowEdit === 'whatsapp_no_company' ? '1px solid black' : 'transparent',
                                                background: allowEdit === 'whatsapp_no_company' ? 'white' : 'transparent',
                                                position: 'relative',
                                                zIndex: 1
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {/* 
                                    <div className='form-group'>
                                      <label className='form-label'>Total Employees</label>
                                      <div className="editable-field">
                                        <div className="position-relative editable-area">
                                          <button className="profile-edit-btn" onClick={() => setAllowEdit(allowEdit === 'total_employees' ? '' : 'total_employees')}>
                                            <i className="fi fi-rr-pencil"></i>
                                          </button>
                                          <input
                                            type="text"
                                            name="total_employees"
                                            value={companyProfile.total_employees}
                                            readOnly={allowEdit !== 'total_employees'}
                                            onChange={handleChange}
                                            className="input-field"
                                            style={{
                                              padding: '5px',
                                              borderRadius: '5px',
                                              border: allowEdit === 'total_employees' ? '1px solid black' : 'transparent',
                                              background: allowEdit === 'total_employees' ? 'white' : 'transparent'
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className='form-group'>
                                      <label className='form-label'>Turn Over</label>
                                      <div className="editable-field">
                                        <div className="position-relative editable-area">
                                          <button className="profile-edit-btn" onClick={() => setAllowEdit(allowEdit === 'turn_over' ? '' : 'turn_over')}>
                                            <i className="fi fi-rr-pencil"></i>
                                          </button>
                                          <input
                                            type="text"
                                            name="turn_over"
                                            value={companyProfile.turn_over}
                                            readOnly={allowEdit !== 'turn_over'}
                                            onChange={handleChange}
                                            className="input-field"
                                            style={{
                                              padding: '5px',
                                              borderRadius: '5px',
                                              border: allowEdit === 'turn_over' ? '1px solid black' : 'transparent',
                                              background: allowEdit === 'turn_over' ? 'white' : 'transparent'
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className='form-group'>
                                      <label className='form-label'>Location</label>
                                      <div className="editable-field">
                                        <div className="position-relative editable-area">
                                          <button className="profile-edit-btn" onClick={() => setAllowEdit(allowEdit === 'address' ? '' : 'address')}>
                                            <i className="fi fi-rr-pencil"></i>
                                          </button>
                                          <input
                                            type="text"
                                            name="address"
                                            value={companyProfile.address}
                                            readOnly={allowEdit !== 'address'}
                                            onChange={handleChange}
                                            className="input-field"
                                            style={{
                                              padding: '5px',
                                              borderRadius: '5px',
                                              border: allowEdit === 'address' ? '1px solid black' : 'transparent',
                                              background: allowEdit === 'address' ? 'white' : 'transparent'
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div> */}

                                    <button className="update-btn btn btn-success mt-4" onClick={handleUpdateProfile}>
                                      Update Profile
                                    </button>
                                  </div>

                                </div>
                              </div>
                            </div>
                            {/* {
                              userDetails?.User_with_Plan?.length > 0 ? ( */}
                            <>
                              <h4 className="mt-4 text-center">Go to your workspace</h4>
                              <div className="mt-3 mb-4">



                                <div className="module-list-wrap">
                                  {purchasedModules?.some(mod => mod.label === "Task") && (
                                    <a href="https://bms.growthh.in/" target="_blank" rel="noopener noreferrer" className="module-checkbox-list-item">
                                      <span className="module-icon"><TaskIcon width={46} className='text-primary' /></span>
                                      <span className="module-name">Task</span>
                                    </a>
                                  )}

                                  {purchasedModules?.some(mod => mod.label === "Checklist") && (
                                    <a href="https://bms.growthh.in/" target="_blank" rel="noopener noreferrer" className="module-checkbox-list-item">
                                      <span className="module-icon"><ChecklistIcon width={46} className='text-primary' /></span>
                                      <span className="module-name">Checksheet</span>
                                    </a>
                                  )}

                                  {purchasedModules?.some(mod => mod.label === "Workflow") && (
                                    <a href="https://bms.growthh.in/" target="_blank" rel="noopener noreferrer" className="module-checkbox-list-item">
                                      <span className="module-icon"><FlowIcon width={46} className='text-primary' /></span>
                                      <span className="module-name">Workflow</span>
                                    </a>
                                  )}

                                  {purchasedModules?.some(mod => mod.label === "ERP") && (
                                    <a href="https://erp.growthh.in/" target="_blank" rel="noopener noreferrer" className="module-checkbox-list-item">
                                      <span className="module-icon"><ErpIcon width={46} className='text-primary' /></span>
                                      <span className="module-name">ERP</span>
                                    </a>
                                  )}

                                  {purchasedModules?.some(mod => mod.label === "POS") && (
                                    <a href="https://erp.growthh.in/" target="_blank" rel="noopener noreferrer" className="module-checkbox-list-item">
                                      <span className="module-icon"><PosIcon width={46} className='text-primary' /></span>
                                      <span className="module-name">POS</span>
                                    </a>
                                  )}
                                </div>

                              </div>
                            </>
                            {/* ) : ( */}
                            <>
                              {/* {
                                  planDetails && ( */}
                              {/* <CartPage skipOrGetStart={skipOrGetStart} planDetails={planDetails} /> */}
                              <>
                              </>
                              {/* )
                                } */}

                            </>
                            {/* )
                            } */}

                          </div>
                        </div>
                        {/* {
                          userDetails?.User_with_Plan?.length > 0 ? (
                            userDetails.User_with_Plan.map((planDetail, index) => ( */}
                        <React.Fragment >
                          <div className='row justify-content-center'>
                            <div className='col-lg-9 col-md-12 col-sm-12'>
                              <div className='card shadow-none border'>
                                <div className='card-header'>
                                  <h5>{
                                    planHistory?.[planHistory.length - 1]?.billing_cycle === 'yearly'
                                      ? 'Yearly Flex'
                                      : planHistory?.[planHistory.length - 1]?.billing_cycle === 'monthly'
                                        ? 'Monthly Flex'
                                        : 'Free Trial'
                                  }</h5>
                                </div>
                                <div className='card-body pb-0'>
                                  <div className="row gx-4 justify-content-center">
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-12 mb-4">
                                      <div className="card current-plan-card h-100">
                                        <div className="card-body">
                                          <div className="current-plan-card-wrap">


                                            {planHistory?.[0]?.expiry_date && new Date(planHistory[0].expiry_date) >= new Date() && (
                                              <span className="badge rounded-pill gth-bg-info ms-2">Active Plan</span>
                                            )}

                                            <h6 className="current-plan-name">{
                                              planHistory?.[planHistory.length - 1]?.billing_cycle === 'yearly'
                                                ? 'Yearly Flex'
                                                : planHistory?.[planHistory.length - 1]?.billing_cycle === 'monthly'
                                                  ? 'Monthly Flex'
                                                  : 'Free Trial'
                                            }</h6>
                                            <p className="expire-text pe-2">
                                              Your plan will expire within <span>{remainingDays} Days </span>
                                            </p>
                                            <div className="d-flex justify-content-between mt-3">
                                              <button className="btn btn-dark btn-sm rounded-4" onClick={handlePlanDetailsGoClick}>View</button>



                                              {isFreePlan || isPaidRenewable ? (
                                                <Link className="btn btn-warning btn-sm rounded-4" to="/modules-renew">
                                                  Renew
                                                </Link>
                                              ) : (
                                                purchasedModules.length < 3 && !isFreePlan && (
                                                  <Link className="btn btn-success btn-sm rounded-4" to="/modules-upgrade">
                                                    Upgrade
                                                  </Link>
                                                )
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="col-lg-6 col-md-6 col-sm-6 col-12 mb-4">
                                      <div className="card user-card h-100">
                                        <div className="card-body">
                                          <div className="user-card-wrap">
                                            <h6>Total Number of Users</h6>
                                            <div className="d-flex align-items-center mt-2">
                                              <span className="users-icon">
                                                <i className="fi fi-rr-users-alt"></i>
                                              </span>
                                              <p className="user-number ps-3">{totalUsers}</p>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                              {companyMeta && (
                                                <p className="left-number">
                                                  Left: <span className="gth-text-danger">{remainingUsers}</span>
                                                </p>
                                              )}
                                              <button id="users-go" className="btn btn-dark btn-sm rounded-4 view-details" onClick={handleUsersGoClick}>View</button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="row gx-4 justify-content-center">
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-12 mb-4">
                                      <div className="card storage-card h-100">
                                        <div className="card-body">
                                          <div className="storage-card-wrap">
                                            <div className="d-flex justify-content-between">
                                              <h6>Your Storage</h6>
                                            </div>
                                            <h2 className="mt-2 fs-2 mb-0 text-muted">Feature Coming Soon</h2>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="col-lg-6 col-md-6 col-sm-6 col-12 mb-4">
                                      <div className="card payment-history h-100">
                                        <div className="card-body">
                                          <div className="payment-card-wrap">
                                            <h6>Total Payment</h6>
                                            <div className="d-flex align-items-center mt-3 amount mb-3">
                                              <i className="fi fi-br-indian-rupee-sign"></i>
                                              <p className="amount-number ps-2">{totalAmountPaid || 0}</p>
                                            </div>
                                            <div className="text-right">
                                              <button className="btn btn-dark btn-sm rounded-4 view-details" onClick={handlePaymentHistoryGoClick}>View History</button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                        {/*     ))) : null
                         }*/}

                      </div>
                    </div>
                    <div className={`tab-pane ${activeTab === 'users' ? 'active' : ''}`} id="users" role="tabpanel">
                      <div className="container pt-5 pb-4">
                        <div className="card">
                          <div className="card-header gth-blue-light-bg d-flex justify-content-between align-items-center">
                            <h5 className="gth-modal-title">Users List</h5>
                            {remainingUsers > 0 ? (
                              <button className="btn btn-success me-0 ms-auto" onClick={createUserModalShow}>
                                Create User
                              </button>
                            ) : null}
                          </div>
                          <div className="card-body">
                            <div className="fixed-table-wrapper">
                              <table className="table mb-0 table-striped fixedTable-head v-align-middle">
                                <thead>
                                  <tr>
                                    <th>User</th>
                                    <th>Role</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {companyUserList && companyUserList.length > 0 ? (
                                    companyUserList.map((user, index) => (
                                      <tr key={index}>
                                        <td>
                                          <div className="profile-wrap">
                                            <div className="exp-avtar">
                                              <img
                                                className="profile-image"
                                                width={40}
                                                height={40}
                                                src={user?.user_photo ? user.user_photo : url + 'default.jpg'}
                                                alt="user"
                                              />
                                            </div>
                                            <div className="ps-2 profile-name-wrap text-truncate">
                                              <h5 className="profile-name text-truncate text-nowrap">{user.name}</h5>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <span>{user.role || 'User'}</span>
                                        </td>
                                        <td>
                                          <span>{user.email}</span>
                                        </td>
                                        <td>
                                          <span>+{user.p_isd} {user.phone_number}</span>
                                        </td>
                                        <td>
                                          <div className="d-flex">
                                            <OverlayTrigger placement="top" overlay={<Tooltip>View</Tooltip>}>
                                              <button className="me-1 table-action-btn" onClick={() => viewUserModalShow(user.id)}>
                                                <i className="fi fi-rs-eye"></i>
                                              </button>
                                            </OverlayTrigger>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                                              <button className="me-1 table-action-btn" onClick={() => editUserModalShow(user.id)}>
                                                <i className="fi fi-rr-pencil"></i>
                                              </button>
                                            </OverlayTrigger>
                                            {index > 0 && (
                                              <OverlayTrigger placement="top" overlay={<Tooltip>Delete</Tooltip>}>
                                                <button className="me-1 table-action-btn" onClick={() => deleteModalShow(user.id)}>
                                                  <i className="fi fi-rr-trash text-exp-red"></i>
                                                </button>
                                              </OverlayTrigger>
                                            )}
                                          </div>
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="5" className="text-center">No active users found.</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={`tab-pane ${activeTab === 'plan' ? 'active' : ''}`} id="plan" role="tabpanel">
                      <div className="container pt-5 pb-4">
                        <div className="card">
                          <div className="card-header gth-blue-light-bg d-flex justify-content-between align-items-center">
                            <h5 className="gth-modal-title">Plan Details</h5>
                          </div>
                          <div className="card-body">
                            <div className="fixed-table-wrapper">

                              <table className="table mb-0 table-striped fixedTable-head">
                                <thead>
                                  <tr>
                                    <th><span className="text-nowrap">Plan Name</span></th>
                                    <th><span className="text-nowrap">Start Date</span></th>
                                    <th><span className="text-nowrap">Date of Expiration</span></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {planHistory.map((plan, index) => {
                                    const isActive = new Date(plan.expiry_date) >= new Date();

                                    return (
                                      <tr key={plan.id}>
                                        <td>
                                          <div className="d-flex align-items-center">
                                            <h6 className="me-2 text-nowrap">
                                              {plan.billing_cycle === 'yearly'
                                                ? 'Yearly Flex'
                                                : plan.billing_cycle === 'monthly'
                                                  ? 'Monthly Flex'
                                                  : 'Free Trial'}
                                            </h6>
                                            {index === 0 && isActive && (
                                              <span className="badge rounded-pill gth-bg-info">Active Plan</span>
                                            )}
                                          </div>
                                        </td>
                                        <td>
                                          <span>
                                            {new Date(plan.start_date).toLocaleDateString('en-GB', {
                                              day: '2-digit',
                                              month: 'short',
                                              year: 'numeric'
                                            })}
                                          </span>
                                        </td>
                                        <td>
                                          <span>
                                            {new Date(plan.expiry_date).toLocaleDateString('en-GB', {
                                              day: '2-digit',
                                              month: 'short',
                                              year: 'numeric'
                                            })}
                                          </span>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>

                              </table>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={`tab-pane ${activeTab === 'paymentHistory' ? 'active' : ''}`} id="paymentHistory" role="tabpanel">
                      <div className="container pt-5 pb-4">
                        <div className="card">
                          <div className="card-header gth-blue-light-bg d-flex justify-content-between align-items-center">
                            <h5 className="gth-modal-title">Payment History</h5>
                          </div>
                          <div className="card-body">
                            <div className="fixed-table-wrapper">
                              <table className="table mb-0 table-striped fixedTable-head">
                                <thead>
                                  <tr>
                                    <th><span className="text-nowrap">Purchase Plan</span></th>
                                    <th><span className="text-nowrap">Purchase Date</span></th>
                                    <th><span className="text-nowrap">Transaction ID</span></th>
                                    <th><span className="text-nowrap">Amount</span></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {paymentData.length === 0 ? (
                                    <tr><td colSpan="4">No payment history found.</td></tr>
                                  ) : (
                                    paymentData.map((item, idx) => (
                                      <tr key={idx}>
                                        <td>
                                          <div className="d-flex align-items-center">
                                            <h6 className="me-2 text-nowrap">
                                              {
                                                item.billing_cycle === 'monthly'
                                                  ? 'Monthly Flex'
                                                  : item.billing_cycle === 'yearly'
                                                    ? 'Yearly Flex'
                                                    : 'Free Trial'
                                              }
                                            </h6>
                                            {idx === 0 && <span className="badge rounded-pill gth-bg-info">Active Plan</span>}
                                          </div>
                                        </td>
                                        <td><span>{new Date(item.payment_date).toLocaleDateString()}</span></td>
                                        <td><span>#{item.razorpay_payment_id}</span></td>
                                        <td><span className="text-nowrap">&#8377; {parseFloat(item.total).toFixed(2)}</span></td>
                                      </tr>
                                    ))
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>

              </div>
            </div>
          </div>
          <div>
            <FooterHomeOne />
          </div>
        </div>

      </div>


      {/* Plan Modal */}
      <Modal show={showPlanModal} onHide={handlePlanModalClose} animation={false} centered backdrop="static" className="fullscreen">
        <Modal.Header closeButton className="gth-blue-light-bg">
          <Modal.Title className="gth-modal-title">Our plans</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-light">
          <div className="row justify-content-center">
            <div className="col-12 mb-5 text-center">
              <h2>Choose the right plan for your team</h2>
              <h4>Thank you for choosing Growthh.com!</h4>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="pricing-one__single">
                <div className="card-active-plan"><span className="badge rounded-pill gth-bg-info">Active Plan</span></div>
                <label className="custom-radio">
                  <input type="radio" name="selectPlan" />
                  <span className="checkmark" />
                  <div className="pricig-heading">
                    <h6>Free Trial</h6>
                    <div className="price-range">
                      <sup></sup> <span>FREE</span>
                    </div>
                    <p>Get your 14 day free trial</p>
                  </div>
                  <div className="pricig-body">
                    <ul>
                      <li>
                        <i className="fal fa-check" /> Doer Management System
                      </li>
                      <li>
                        <i className="fal fa-check" /> Repeated Work Management
                      </li>
                      <li>
                        <i className="fal fa-check" /> Task Tracker
                      </li>
                      <li>
                        <i className="fal fa-check" /> Bottleneck Management
                      </li>
                      <li>
                        <i className="fal fa-check" /> Workflows (FMS) <br />(Free upto 1 FMS)
                      </li>
                      <li>
                        <i className="fal fa-check" /> Admin & Doer Dashboard
                      </li>
                      <li>
                        <i className="fal fa-check" /> Weekly Productivity Report
                      </li>
                      <li>
                        <i className="fal fa-check" /> Doer Performance Report
                      </li>
                      <li>
                        <i className="fal fa-check" /> Organisation Privilege's
                      </li>
                      <li>
                        <i className="fal fa-check" /> Auto Productivity Score
                      </li>
                      <li>
                        <i className="fal fa-check" /> Auto Notification Feature
                      </li>
                      <li>
                        <i className="fal fa-check" /> Employee Comparision Score
                      </li>
                      <li>
                        <i className="fal fa-check" /> Automated Reminder
                      </li>
                      <li>
                        <i className="fal fa-check" /> Whatsapp Reminder (API#)
                      </li>
                      <li>
                        <i className="fal fa-check" /> 3 Users
                      </li>
                      <li>
                        <i className="fal fa-check" /> Storage Space <br />(Upto 50 MB)*
                      </li>
                    </ul>
                  </div>
                </label>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="pricing-one__single">
                <div className="card-active-plan"><span className="badge rounded-pill gth-bg-success">Upgrade Plan</span></div>
                <label className="custom-radio">
                  <input type="radio" name="selectPlan" />
                  <span className="checkmark" />
                  <div className="pricig-heading business-growth">
                    <h6>Business Growth</h6>
                    <div className="price-range">
                      <sup>&#8377;</sup> <span>1,999</span>
                      <p>/month <mark className='bg-transparent text-danger'>**</mark></p>
                    </div>
                    <p>( Charged every 30 days )</p>
                  </div>
                  <div className="pricing-rebon">
                    <span>Most Popular</span>
                  </div>
                  <div className="pricig-body">
                    <ul>
                      <li>
                        <i className="fal fa-check" /> Doer Management System
                      </li>
                      <li>
                        <i className="fal fa-check" /> Repeated Work Management
                      </li>
                      <li>
                        <i className="fal fa-check" /> Task Tracker
                      </li>
                      <li>
                        <i className="fal fa-check" /> Bottleneck Management
                      </li>
                      <li>
                        <i className="fal fa-check" /> Workflows (FMS) <br />(Upto 3 FMS)
                      </li>
                      <li>
                        <i className="fal fa-check" /> Admin & Doer Dashboard
                      </li>
                      <li>
                        <i className="fal fa-check" /> Weekly Productivity Report
                      </li>
                      <li>
                        <i className="fal fa-check" /> Doer Performance Report
                      </li>
                      <li>
                        <i className="fal fa-check" /> Organisation Privilege's
                      </li>
                      <li>
                        <i className="fal fa-check" /> Auto Productivity Score
                      </li>
                      <li>
                        <i className="fal fa-check" /> Auto Notification Feature
                      </li>
                      <li>
                        <i className="fal fa-check" /> Employee Comparision Score
                      </li>
                      <li>
                        <i className="fal fa-check" /> Automated Reminder
                      </li>
                      <li>
                        <i className="fal fa-check" /> Whatsapp Reminder (API#)
                      </li>
                      <li>
                        <i className="fal fa-check" /> 10 Users
                      </li>
                      <li>
                        <i className="fal fa-check" /> Storage Space <br />(Upto 2 GB)*
                      </li>
                    </ul>
                  </div>
                </label>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="pricing-one__single">
                <div className="card-active-plan"><span className="badge rounded-pill gth-bg-success">Upgrade Plan</span></div>
                <label className="custom-radio">
                  <input type="radio" name="selectPlan" />
                  <span className="checkmark" />
                  <div className="pricig-heading express">
                    <h6>Business Express</h6>
                    <div className="price-range">
                      <sup>&#8377;</sup> <span>4,999</span>
                      <p>/month <mark className='bg-transparent text-danger'>**</mark></p>
                    </div>
                    <p>( Charged every 30 days )</p>
                  </div>
                  <div className="pricig-body">
                    <ul>
                      <li>
                        <i className="fal fa-check" /> Doer Management System
                      </li>
                      <li>
                        <i className="fal fa-check" /> Repeated Work Management
                      </li>
                      <li>
                        <i className="fal fa-check" /> Task Tracker
                      </li>
                      <li>
                        <i className="fal fa-check" /> Bottleneck Management
                      </li>
                      <li>
                        <i className="fal fa-check" /> Workflows (FMS) <br />(Upto 5 FMS)
                      </li>
                      <li>
                        <i className="fal fa-check" /> Admin & Doer Dashboard
                      </li>
                      <li>
                        <i className="fal fa-check" /> Weekly Productivity Report
                      </li>
                      <li>
                        <i className="fal fa-check" /> Doer Performance Report
                      </li>
                      <li>
                        <i className="fal fa-check" /> Organisation Privilege's
                      </li>
                      <li>
                        <i className="fal fa-check" /> Auto Productivity Score
                      </li>
                      <li>
                        <i className="fal fa-check" /> Auto Notification Feature
                      </li>
                      <li>
                        <i className="fal fa-check" /> Employee Comparision Score
                      </li>
                      <li>
                        <i className="fal fa-check" /> Automated Reminder
                      </li>
                      <li>
                        <i className="fal fa-check" /> Whatsapp Reminder (API#)
                      </li>
                      <li>
                        <i className="fal fa-check" /> 30 Users
                      </li>
                      <li>
                        <i className="fal fa-check" /> Storage Space <br />(Upto 5 GB)*
                      </li>
                    </ul>
                  </div>
                </label>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="pricing-one__single">
                <div className="card-active-plan"><span className="badge rounded-pill gth-bg-success">Upgrade Plan</span></div>
                <label className="custom-radio">
                  <input type="radio" name="selectPlan" />
                  <span className="checkmark" />
                  <div className="pricig-heading enterprise">
                    <h6>Enterprise</h6>
                    <div className="price-range">
                      <div className='requirement'>As per Requirement</div>
                    </div>
                    <p>( Charged every 30 days )</p>
                  </div>
                  <div className="pricig-body">
                    <ul>
                      <li>
                        <i className="fal fa-check" /> Doer Management System
                      </li>
                      <li>
                        <i className="fal fa-check" /> Repeated Work Management
                      </li>
                      <li>
                        <i className="fal fa-check" /> Task Tracker
                      </li>
                      <li>
                        <i className="fal fa-check" /> Bottleneck Management
                      </li>
                      <li>
                        <i className="fal fa-check" /> Workflows (FMS) <br />(As per requirement)
                      </li>
                      <li>
                        <i className="fal fa-check" /> Admin & Doer Dashboard
                      </li>
                      <li>
                        <i className="fal fa-check" /> Weekly Productivity Report
                      </li>
                      <li>
                        <i className="fal fa-check" /> Doer Performance Report
                      </li>
                      <li>
                        <i className="fal fa-check" /> Organisation Privilege's
                      </li>
                      <li>
                        <i className="fal fa-check" /> Auto Productivity Score
                      </li>
                      <li>
                        <i className="fal fa-check" /> Auto Notification Feature
                      </li>
                      <li>
                        <i className="fal fa-check" /> Employee Comparision Score
                      </li>
                      <li>
                        <i className="fal fa-check" /> Automated Reminder
                      </li>
                      <li>
                        <i className="fal fa-check" /> Whatsapp Reminder (API#)
                      </li>
                      <li>
                        <i className="fal fa-check" /> Users (As per requirement)*
                      </li>
                      <li>
                        <i className="fal fa-check" /> Storage Space <br />(As per requirement)*
                      </li>
                    </ul>
                  </div>
                </label>
              </div>
            </div>
            <div className="col-12">
              <p className='mb-2 mt-50'>
                Safe & Secure Data Encryption for Advanced Security. All transmissions to and from Growthh.com, including sign-on, are encrypted at 256-bit and sent through TLS 1.2, adhering to the FIPS 140-2 certification standard.
              </p>
              <p className='mb-2'>
                <mark className='bg-transparent text-danger'>**</mark> GST charges are included.
              </p>
              <p className='mb-2'>
                <mark className='bg-transparent text-danger'>#</mark>Whatsapp API cost charge not included.
              </p>
              <p>
                <mark className='bg-transparent text-dark'>*</mark> Storage is limited with plans. For additional storage contact support at <a href="mailto:crm@growthh.com" className="gth-text-primary1">crm@growthh.com</a>
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="gth-btn-primary" onClick={handlePlanModalClose}>
            Continue
          </button>
        </Modal.Footer>
      </Modal>
      {/* Plan Modal End*/}
      {/* Storage Modal*/}
      <Modal show={showStorageModal} onHide={handleStorageModalClose} animation={false} centered backdrop="static" size="xl">
        <Modal.Header closeButton className="gth-blue-light-bg">
          <Modal.Title className="gth-modal-title">Upgrade Storage Plans</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-light">
          <div className="row justify-content-center">
            <div className="col-12 mb-5 text-center">
              <h2>Choose the right storage plan for your team</h2>
              <h4 className="text-muted">Thank you for choosing Growthh.com!</h4>
              <p className="mt-3">
                Storage upgrades are charged with base plans. The validity of the storage remains as long as there is a base plan subscription. Without a base plan you can not use this storage.
              </p>
            </div>
            <div className="col-12">
              <div className="storage-plan-wrap">
                <div className="storage-plan-item">
                  <label className="custom-radio">
                    <input type="radio" name="selectStoragePlan" />
                    <span className="checkmark" />
                    <div className="storage-heading">
                      <h6>Cloud 2GB</h6>
                      <div className="storage-unit">
                        <i class="fi fi-rr-cloud-back-up me-2"></i><span>2 GB</span>
                      </div>
                      <div className="storage-price">
                        <>&#8377;</> <span>999</span>
                        <p>/month</p>
                      </div>
                    </div>
                  </label>
                </div>
                <div className="storage-plan-item">
                  <label className="custom-radio">
                    <input type="radio" name="selectStoragePlan" />
                    <span className="checkmark" />
                    <div className="storage-heading">
                      <h6>Cloud 5GB</h6>
                      <div className="storage-unit">
                        <i class="fi fi-rr-cloud-back-up me-2"></i><span>5 GB</span>
                      </div>
                      <div className="storage-price">
                        <>&#8377;</> <span>1,999</span>
                        <p>/month</p>
                      </div>
                    </div>
                  </label>
                </div>
                <div className="storage-plan-item">
                  <label className="custom-radio">
                    <input type="radio" name="selectStoragePlan" />
                    <span className="checkmark" />
                    <div className="storage-heading">
                      <h6>Cloud 10GB</h6>
                      <div className="storage-unit">
                        <i class="fi fi-rr-cloud-back-up me-2"></i><span>10 GB</span>
                      </div>
                      <div className="storage-price">
                        <>&#8377;</> <span>3,499</span>
                        <p>/month</p>
                      </div>
                    </div>
                  </label>
                </div>
                <div className="storage-plan-item">
                  <label className="custom-radio">
                    <input type="radio" name="selectStoragePlan" />
                    <span className="checkmark" />
                    <div className="storage-heading">
                      <h6>Cloud 20GB</h6>
                      <div className="storage-unit">
                        <i class="fi fi-rr-cloud-back-up me-2"></i><span>20 GB</span>
                      </div>
                      <div className="storage-price">
                        <>&#8377;</> <span>5,999</span>
                        <p>/month</p>
                      </div>
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div className="col-12">
              <p className='mb-0 mt-40 text-center'>
                Once storage plans are upgraded, it can not be downgraded. For more information kindly contact <a href="mailto:crm@growthh.com">crm@growthh.com</a>
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="gth-btn-primary" onClick={handleStorageModalClose}>
            Continue
          </button>
        </Modal.Footer>
      </Modal>
      {/* Storage Modal End*/}
      {/* Delete modal start */}
      <Modal
        show={deleteShow}
        onHide={deleteModalClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton className="gth-light-red-bg">
          <Modal.Title className="gth-text-danger">Delete Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-confirm-wrap text-center">
            <div className="delete-confirm-icon mb-3 mt-2">
              <img src={process.env.PUBLIC_URL + 'assets/images/delete-warning.svg'} alt="Warning" className="img-fluid" />
            </div>
            <h4 className="text-muted">Are you sure?</h4>
            <p className="text-muted">
              Do you really want to delete these record? This process cannot be undone.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className='justify-content-center'>
          <button className='btn btn-secondary' onClick={deleteModalClose}>
            Cancel
          </button>
          <button className='btn btn-exp-red' onClick={(e) => { handleUserDelete(e) }}>
            Delete
          </button>
        </Modal.Footer>
      </Modal>
      {/* Delete modal end */}
      {/* Create User modal start */}
      <Modal
        show={createUserShow}
        onHide={() => {
          setCompanyUser(
            {
              name: '',
              email: '',
              password: '',
              contact_no: 0,
              whats_app_number: 0,
              profile_image: "",
              w_isd: '',
              p_isd: ''
            }
          ); createUserModalClose();
        }}
        backdrop="static"
        keyboard={false}
        centered
        size="lg"
      >
        <Modal.Header closeButton className="gth-blue-light-bg">
          <Modal.Title className="gth-modal-title">Create User</Modal.Title>
        </Modal.Header>
        <Modal.Body className='pb-1'>
          <div className='row'>
            <div className='col-md-6'>
              <div className="form-group">
                <label className="form-label">Name</label>
                <input type="text" className="form-control" placeholder="Enter user name" name="name" onChange={(e) => { handleCompanyUserChange(e) }} />
                {errors.name && <div className="text-danger">{errors.name}</div>}

              </div>
            </div>

            <div className='col-md-6'>
              <div className="form-group">
                <label className="form-label">password</label>
                <input type="password" className="form-control" placeholder="Enter user password" name="password" onChange={(e) => { handleCompanyUserChange(e) }}
                  value={companyUser.password}
                />
                {errors.password && <div className="text-danger">{errors.password}</div>}

              </div>
            </div>
            {/* <div className='col-md-6'>
              <div className="form-group">
                <label className="form-label">Role</label>
                <Select
                  name='role'
                  value={companyUser.role}
                  options={roleType}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: '#ddddff',
                      primary: '#6161ff',
                    },
                  })}
                  onChange={(selectedOption) => { handleCompanyUserRole(selectedOption) }}
                />
              </div>
            </div> */}
            <div className='col-md-6'>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input type="email" className="form-control" placeholder="Enter user email" name="email" onChange={(e) => { handleCompanyUserChange(e) }}

                />
                {errors.email && <div className="text-danger">{errors.email}</div>}
              </div>
            </div>
            <div className='col-md-6'>
              <div className="form-group">
                <label className="form-label">Phone</label>
                <PhoneInput
                  name="contact_no"
                  country={'in'}

                  onChange={phone => handleCompanyUserContact({ phone })}
                />
                {errors.contact_no && <div className="text-danger">{errors.contact_no}</div>}

              </div>
            </div>
            <div className='col-md-6'>
              <div className="form-group">
                <label className="form-label">WhatsApp</label>
                <PhoneInput
                  name="whats_app_number"
                  country={'in'}

                  onChange={phone => handleCompanyUserWhatsApp({ phone })}
                />
                {errors.whats_app_number && <div className="text-danger">{errors.whats_app_number}</div>}

              </div>
            </div>

            <div className='col-md-6'>
              <div className="form-group">
                <label className="form-label">Upload image</label>
                <input type="file" className="form-control" name="userProfileImage" onChange={(e) => { setSelectedFile(e.target.files[0], 'e.target') }}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-success' onClick={(e) => { handleSubmit(e) }}>
            Confirm
          </button>
        </Modal.Footer>
      </Modal>
      {/* Create User modal end */}
      {/* View User modal start */}
      <Modal show={viewUserShow} onHide={viewUserModalClose} backdrop="static" keyboard={false} centered size="lg">
        <Modal.Header closeButton className="gth-blue-light-bg">
          <Modal.Title className="gth-modal-title">{updateCompanyUser?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body className='pb-1'>
          <div className='row'>
            <div className='col-md-6'>
              <div className="form-group">
                <label className="form-label">User name</label>
                <div className="profile-wrap">
                  <div className="exp-avtar bg-exp-yellow">
                    <img
                      className="prof-img"
                      src={(updateCompanyUser?.user_photo ? updateCompanyUser.user_photo : url + 'default.jpg')}
                      alt="user"
                    />
                  </div>
                  <div className="ps-2 profile-name-wrap text-truncate">
                    <h5 className="profile-name text-nowrap text-truncate">{updateCompanyUser?.name}</h5>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-md-6'>
              <div className="form-group">
                <label className="form-label">Role</label>
                <p>Owner</p>
              </div>
            </div>

            <div className='col-md-6'>
              <div className="form-group">
                <label className="form-label">Email</label>
                <p>{updateCompanyUser?.email}</p>
              </div>
            </div>

            <div className='col-md-6'>
              <div className="form-group">
                <label className="form-label">Phone</label>
                <p>+{updateCompanyUser.p_isd} {updateCompanyUser?.phone_number}</p>
              </div>
            </div>

            <div className='col-md-6'>
              <div className="form-group">
                <label className="form-label">WhatsApp</label>
                <p>+{updateCompanyUser.w_isd} {updateCompanyUser?.whatsapp_no}</p>
              </div>
            </div>


          </div>
        </Modal.Body>
      </Modal>

      {/* View User modal end */}
      {/* Edit User modal start */}
      <Modal
        show={editUserShow}
        onHide={editUserModalClose}
        backdrop="static"
        keyboard={false}
        centered
        size="lg"
      >
        <Modal.Header closeButton className="gth-blue-light-bg">
          <Modal.Title className="gth-modal-title">Edit User</Modal.Title>
        </Modal.Header>
        <Modal.Body className='pb-1'>
          <div className='row'>
            <div className='col-md-6'>
              <div className="form-group">
                <label className="form-label">Name</label>
                <input type="text" className="form-control" placeholder="Enter Name" name="name" onChange={(e) => { handleUpdateChange(e) }} value={updateCompanyUser.name} />
              </div>
            </div>
            <div className='col-md-6'>
              <div className="form-group">
                <label className="form-label">password</label>
                <input type="password" className="form-control" placeholder="Enter user password" name="password" onChange={(e) => { handleUpdateChange(e) }}
                  value={updateCompanyUser.password}
                />
              </div>
            </div>
            <div className='col-md-6'>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input type="email" className="form-control" placeholder="Enter user email" name="email" onChange={(e) => { handleUpdateChange(e) }} value={updateCompanyUser.email} />
              </div>
            </div>
            <div className='col-md-6'>
              <div className="form-group">
                <label className="form-label">Phone</label>
                {console.log(`${updateCompanyUser}`)
                }
                <PhoneInput
                  country={'in'}
                  value={`${updateCompanyUser.p_isd}${updateCompanyUser.contact_no}`}
                  onChange={(value, country) => {
                    const code = `${country.dialCode}`;
                    const number = value.replace(code, '');
                    setUpdateCompanyUser({ ...updateCompanyUser, contact_no: number, p_isd: code })
                  }}
                // onChange={phone => setUpdateCompanyUser({ phone })}
                />
              </div>
            </div>
            <div className='col-md-6'>
              <div className="form-group">
                <label className="form-label">WhatsApp</label>
                <PhoneInput
                  country={'in'}
                  value={`${updateCompanyUser.w_isd}${updateCompanyUser.whats_app_number}`}
                  onChange={(value, country) => {
                    const code = `${country.dialCode}`;
                    const number = value.replace(code, '');
                    setUpdateCompanyUser({ ...updateCompanyUser, whats_app_number: number, w_isd: code })
                  }}

                />
              </div>
            </div>

            <div className='col-md-6'>
              <div className="form-group">
                <label className="form-label">Upload image</label>
                <input type="file" className="form-control" name="userProfileImage" onChange={(e) => { setSelectedFile(e.target.files[0]) }}
                />
              </div>
              {updateCompanyUser.user_photo && (
                <div className="mt-2">
                  <img
                    src={`${updateCompanyUser.user_photo}`}
                    alt="User"
                    height="50"
                  />
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-success' onClick={(e) => { handleUserUpdate(e) }}>
            Update
          </button>
        </Modal.Footer>
      </Modal>
      {/* Edit User modal end */}
      {/* Profile image modal start */}
      <Modal
        show={profileImageModalShow}
        onHide={handleProfileImageModalClose}
        backdrop="static"
        keyboard={false}
        centered
        size="md"
      >
        <Modal.Header closeButton className="gth-blue-light-bg">
          <Modal.Title className="gth-modal-title">Profile Image </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='col-md-12'>
              <AvatarEditor
                ref={editorRef}
                image={showImage}
                width={200}
                height={200}
                border={40}
                borderRadius={150}
                color={[0, 0, 0, 0.72]}
                scale={scale}
                className="avtar-editor-wrap"
              />
              <div className="form-group mt-3">
                <label htmlFor="upload" className="form-label">Upload Image:</label>
                <input
                  type="file"
                  className="form-control"
                  id="upload"
                  onChange={(e) => { setImage(e.target.files[0]); setShowImage(URL.createObjectURL(e.target.files[0])) }}
                />
              </div>
              <div className="form-group mt-3">
                <label htmlFor="scale" className="form-label">Scale:</label>
                <input
                  type="range"
                  className="form-control-range"
                  id="scale"
                  value={scale}
                  min="1"
                  max="2"
                  step="0.01"
                  onChange={handleScaleChange}
                />
              </div>
              <div className="mt-3 d-flex justify-content-end">
                <button className="btn btn-success" onClick={handleSave}>Crop</button>
              </div>

            </div>

          </div>
        </Modal.Body>

      </Modal>
      {/* Profile image modal end */}
      {/* Video Tutorial Modal for New Users */}
      <VideoTutorialModalNewUser
        show={showVideoNewUserModal}
        onClose={handleVideoNewUserModalClose}
        videoUrl="https://www.youtube.com/embed/AHRfih5JiP8"
      />
      {/* Video Tutorial Modal for New Users end */}

    </>
  )
}

export default UserDashboardIndex


